"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecapStatus = void 0;
var RecapStatus;
(function (RecapStatus) {
    RecapStatus["PENDING"] = "pending";
    RecapStatus["PROCESSING"] = "processing";
    RecapStatus["COMPLETED"] = "completed";
    RecapStatus["FAILED"] = "failed";
})(RecapStatus || (exports.RecapStatus = RecapStatus = {}));
